import { render, staticRenderFns } from "./SiestaTimer.vue?vue&type=template&id=459d0ca0&scoped=true&"
import script from "./SiestaTimer.vue?vue&type=script&lang=js&"
export * from "./SiestaTimer.vue?vue&type=script&lang=js&"
import style0 from "./SiestaTimer.vue?vue&type=style&index=0&id=459d0ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459d0ca0",
  null
  
)

export default component.exports